import isEqual from 'lodash/isEqual';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDeals } from 'store/promoArea/promoAreaActions';
import { getLocationDealsQuery } from 'store/search/searchSelectors/querySelectors';

const PromoAreaDealsFetcher = () => {
  const dispatch = useDispatch();
  const [previousQuery, setPreviousQuery] = useState(null);

  const query = useSelector(getLocationDealsQuery);

  useEffect(() => {
    if (!isEqual(query, previousQuery)) {
      dispatch(fetchDeals());
      setPreviousQuery(query);
    }
  }, [query, dispatch, previousQuery]);

  return null;
};

export default PromoAreaDealsFetcher;
